module.exports = __webpack_public_path__ + "static/img/p4_3.c0e6d96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/p4_3.png
// module id = hZ64
// module chunks = 0